import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import { SgdsMasthead } from "@govtechsg/sgds-masthead-react";

import Navbar from "../../Components/NavbarComponent";
import FooterComponent from "../../Components/FooterComponent";
import SideNavComponent from "../../Components/SideNavComponent";
import MastheadAnnouncement from '../../Components/MastheadAnnouncement'

import Endpoint from "../../Components/Endpoint";
import endpointsData from "../../json/sampleEndpts.json";

import { Button } from "@govtechsg/sgds-react/Button";
import arrowleft from "../../assets/icons/arrow-left.svg";
import arrowright from "../../assets/icons/arrow-right.svg";

const PopulationQueryServices = () => {
  const location = useLocation();
  
  const endpointreturn = (id) => {
    let endpt_elem = endpointsData;

    endpt_elem = endpt_elem.find((item) => item.page_section === id);

    const pythonCode = `import requests
    \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
    \nheaders = {"Authorization": "**********************"}
    \nresponse = requests.request("GET", url, headers=headers)
    \nprint(response.text)`;

    const jsCode = `const url = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}";
const authToken = '**********************';  // Replace with your access token

fetch(url, {
  method: '${endpt_elem.method}',
  headers: {
    'Authorization': \`\${authToken}\`,  // API token for authorization
  }
})
.then(response => response.json())  // Parse response as JSON
.then(data => console.log(data))     // Log the data to the console
.catch(error => console.error('Error:', error));  // Log any errors`;

    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const { state } = location;
  const [activeKey, setActiveKey] = useState("");
  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };
  useEffect(() => {
    if (state === null) {
      clickButton("0");
    } else {
      clickButton(location.state.toString());
    }
  }, [state]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>

      <Helmet>
        <title>Population Query | Access Singapore's Demographic Data by Planning Area</title>
        <meta
          name="description"
          content="Explore comprehensive population datasets from Singapore's Department of Statistics using the Population Query API. Retrieve detailed demographic information, including economic status, household income, household size, marital status and other population API based on planning area or subzone for specific years."
        />
      </Helmet>
      <MastheadAnnouncement/>
      <Navbar />
      <div className="row qx-0 mb-5 position-relative">
        <div className="col-1 d-md-none d-inline">
          <div
            className="btn btn-primary d-md-none position-fixed sideBarBtn"
            onClick={(e) => {
              handleCollapse();
              if (isCollapsed) {
                window.scrollTo(0, 0);
              }
            }}
          >
            Show Side Bar
          </div>
        </div>

        <div
          className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? "collapse" : ""
          }`}
        >
          <SideNavComponent />
        </div>

        <div className="col-12 col-md-9 qx-0 px-3">
          <>
            <div className="om-population-section">
              <h1>Population Query</h1>
              <div className="om-population-intro">
                <p>
                  This API provides population data sets by the Department of
                  Statistics. The types of population demographics data, based
                  on planning area or subzone, include age group, economic
                  status, education status, household size etc.
                </p>
                <br />
              </div>
              <h1 id="economicStatusData">Economic Status Data</h1>
              <div className="om-population-intro">
                <p>
                  This API retrieves data related to economic status for given
                  planning area name and year. If gender is not specified, then
                  result set would contain figures for both genders, male and
                  female.
                </p>
              </div>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token.
                </p>
                <p className="slate-p">400 - Please enter valid year.</p>
                <p className="slate-p">400 - Please enter planning area.</p>
                <p className="slate-p">
                  400 - Your gender must be either male or female.
                </p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      gender
                      <span className="label-type">string</span>
                      {/* <span className='label-required'>
									Required
								</span> */}
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Optional. Male or female, returns all results by
                        default.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getEconomicStatus")} />
              {/* education status */}
              <h1 id="educationStatusData">Education Status Data</h1>
              <p>
                This API retrieves data related to education status for given
                planning area name and year.
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token.
                </p>
                <p className="slate-p">400 - Please enter valid year.</p>
                <p className="slate-p">400 - Please enter planning area.</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
              </div>
              <div className="om-population-items">
                <div className="om-population-item">
                  <div className="label-method">
                    Authorization
                    <span className="label-type">string</span>
                    <span className="label-required">Required</span>
                  </div>
                  <div className="om-population-desc">
                    <p>API token provided by the Authentication Service.</p>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getEducationAttending")} />
              <h1 id="ethnicDistribution">Ethnic distribution Data</h1>
              <p>
                This API retrieves data related to ethnic distribution for given
                planning area name and year. If gender is not specified, then
                result set would contain figures for both genders, male and
                female.
              </p>
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      gender
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Optional. Gender can be either male or female. Returns
                        all results by default.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getEthnicGroup")} />
              {/* work income for household monthly */}
              <h1 id="workIncomeForHouseHold">
                Work Income for household (monthly)
              </h1>
              <p>
                This API retrieves data related to monthly household income for
                given planning area name and year.
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token.
                </p>
                <p className="slate-p">400 - Please enter planning area.</p>
                <p className="slate-p">400 - Please enter valid year.</p>
                {/* <p className='slate-p'>400 - Your gender must be either male or female!</p> */}
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getHouseholdMonthlyIncomeWork")} />
              <h1 id="householdSizeData">Household size data</h1>
              <p>
                <span className="slate-color">
                  This API retrieves data related to household size for given
                  planning area name and year.
                </span>
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token
                </p>
                <p className="slate-p">400 - Please enter planning area</p>
                <p className="slate-p">400 - Please enter valid year</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getHouseholdSize")} />
              <h1 id="householdStructureData">Household structure data</h1>
              <p>
                <span className="slate-color">
                  This API retrieves data related to household structure for
                  given planning area name and year.
                </span>
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token
                </p>
                <p className="slate-p">400 - Please enter planning area</p>
                <p className="slate-p">400 - Please enter valid year</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getHouseholdStructure")} />
              {/* income from work */}
              <h1 id="incomeFrWork">Income from work data</h1>
              <p>
                This API retrieves data related to income from work for given
                planning area name and year.
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token
                </p>
                <p className="slate-p">400 - Please enter planning area</p>
                <p className="slate-p">400 - Please enter valid year</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getIncomeFromWork")} />
              {/* industry of population */}
              <h1 id="industryOfPopulationData">Industry of population</h1>
              <p>
                <span className="slate-color">
                  This API retrieves data related to industry of population for
                  given planning area name and year.
                </span>
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token
                </p>
                <p className="slate-p">400 - Please enter planning area</p>
                <p className="slate-p">400 - Please enter valid year</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getIndustry")} />
              {/* lang literacy */}
              <h1 id="languageLiteracyData">Language literacy data</h1>
              <p>
                <span className="slate-color">
                  This API retrieves data related to language literacy for given
                  planning area name and year.
                </span>
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token
                </p>
                <p className="slate-p">400 - Please enter planning area</p>
                <p className="slate-p">400 - Please enter valid year</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getLanguageLiterate")} />
              {/* martial status */}
              <h1 id="maritalStatusData">Marital Status data</h1>
              <p>
                This API retrieves data related to marital status for given
                planning area name and year.
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token
                </p>
                <p className="slate-p">400 - Please enter planning area</p>
                <p className="slate-p">400 - Please enter valid year</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      gender
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Optional. Gender can be either male or female. Returns
                        all results by default.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getMaritalStatus")} />
              {/* mode of transport school */}
              <h1 id="modeOfTransportSchool">Mode of transport to school</h1>
              <p>
                This API retrieves data related to mode of transport to school
                for given planning area name and year.
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token
                </p>
                <p className="slate-p">400 - Please enter planning area</p>
                <p className="slate-p">400 - Please enter valid year</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getModeOfTransportSchool")} />
              {/* mode of transport - work */}
              <h1 id="modeOfTransportSchool">Mode of transport to work</h1>
              <p>
                This API retrieves data related to mode of transport to work for
                given planning area name and year.
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token.
                </p>
                <p className="slate-p">400 - Please enter planning area.</p>
                <p className="slate-p">400 - Please enter valid year.</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getModeOfTransportWork")} />
              {/* age data */}
              <h1 id="ageData">Age Data</h1>
              <p>
                <span className="slate-color">
                  This API retrieves data related to age for given planning area
                  name and year.
                </span>
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token.
                </p>
                <p className="slate-p">400 - Please enter planning area.</p>
                <p className="slate-p">400 - Please enter valid year.</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      gender
                      <span className="label-type">string</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Optional. Male or female, returns all results by
                        default.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getPopulationAgeGroup")} />
              {/* religion */}
              <h1 id="religionData">Religion Data</h1>
              <p>
                <span className="slate-color">
                  This API retrieves data related to religion for given planning
                  area name and year.
                </span>
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token.
                </p>
                <p className="slate-p">400 - Please enter planning area.</p>
                <p className="slate-p">400 - Please enter valid year.</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getReligion")} />
              {/* spoken lang */}
              <h1 id="spokenLangData">Spoken language data</h1>
              <p>
                This API retrieves data related to spoken language for given
                planning area name and year.
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token.
                </p>
                <p className="slate-p">400 - Please enter planning area.</p>
                <p className="slate-p">400 - Please enter valid year.</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getSpokenAtHome")} />
              {/* tenancy */}
              <h1 id="tenancyData">Tenancy data</h1>
              <p>
                This API retrieves data related to tenancy for the given
                planning area name and year.
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token.
                </p>
                <p className="slate-p">400 - Please enter planning area.</p>
                <p className="slate-p">400 - Please enter valid year.</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getTenancy")} />
              {/* dwelling type household data */}
              <h1 id="dwellingTypeHouseholdData">
                Dwelling type household data
              </h1>
              <p>
                This API retrieves data related to dwelling type household for
                given the planning area name and year.
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token.
                </p>
                <p className="slate-p">400 - Please enter planning area.</p>
                <p className="slate-p">400 - Please enter valid year.</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getTypeOfDwellingHousehold")} />
              <h1 id="dwellingTypePopulationData">
                Dwelling type population data
              </h1>
              <p>
                <span className="slate-color">
                  This API retrieves data related to dwelling type population
                  for the given planning area name and year.
                </span>
              </p>
              <h3 className="om-population-err">
                <strong className="slate-bold">Possible Error Responses</strong>
              </h3>
              <div>
                <p className="slate-p">
                  400 - Please send the access token either in the request
                  header as a bearer token
                </p>
                <p className="slate-p">400 - Please enter planning area.</p>
                <p className="slate-p">400 - Please enter valid year.</p>
                <p className="slate-p">
                  401 - Token has expired: Session expired. Please refresh your
                  token (if still within refresh window) or re-login.
                </p>
                <p className="slate-p">
                  401 - Invalid token: Could not decode token: The token xxx; is
                  an invalid JWS.
                </p>
                <p className="slate-p">
                  403 - Access Forbidden. GET access to component 'xxx' of
                  service 'xxx' is not allowed by this user's role.
                </p>
                <p className="slate-p">429 - API limit(s) exceeded.</p>
              </div>
              <br />
              <div className="om-population-wrapper">
                <div className="om-reverseGeocode">
                  <h4 className="om-reverseGeocode-header">
                    HEADER PARAMETERS
                  </h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      Authorization
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>API token provided by the Authentication Service.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="om-population-wrapper">
                <div className="om-theme">
                  <h4 className="om-theme-header">QUERY PARAMETERS</h4>
                </div>
                <div className="om-population-items">
                  <div className="om-population-item">
                    <div className="label-method">
                      planningArea
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>
                        Planning area name can be retrieved from "Names of
                        planning area".
                      </p>
                    </div>
                  </div>
                  <div className="om-population-item">
                    <div className="label-method">
                      year
                      <span className="label-type">string</span>
                      <span className="label-required">Required</span>
                    </div>
                    <div className="om-population-desc">
                      <p>Years available are 2000, 2010, 2015, and 2020.</p>
                    </div>
                  </div>
                </div>
              </div>
              <Endpoint {...endpointreturn("getTypeOfDwellingPop")} />
              <br />
              <div
                className="d-flex justify-content-between"
                style={{ marginBottom: "20px" }}
              >
                <div className="d-flex justify-content-start">
                  <Button
                    onClick={() => {
                      clickButton("7");
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    style={{
                      backgroundColor: "#FFFFFF",
                      color: "#000000",
                      border: "none",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src={arrowleft}
                        alt="arrowleft"
                        style={{ color: "#1978FF", marginRight: "10px" }}
                      />
                      <b>Planning Area</b>
                    </div>
                  </Button>
                </div>
                <div className="d-flex justify-content-end">
                  <Button
                    onClick={() => {
                      clickButton("9");
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    style={{
                      backgroundColor: "#FFFFFF",
                      color: "#000000",
                      border: "none",
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <b>Static Map</b>{" "}
                      <img
                        src={arrowright}
                        alt="arrowright"
                        style={{ color: "#1978FF", marginLeft: "10px" }}
                      />
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
      <FooterComponent />
    </>
  );
};
export default PopulationQueryServices;
